import styles from './SubPageTop.module.css';
import { useLocation } from 'react-router-dom';

// 페이지별 그라데이션 색상 설정 (RGB 값)
const getPageColor = (pathname) => {
    const pageColors = {
        '/about': { r: 254, g: 140, b: 134 },
        '/news': { r: 169, g: 168, b: 232 },
        '/news/notice': { r: 169, g: 168, b: 232 },
        '/news/press': { r: 169, g: 168, b: 232 },
        '/news/seminar': { r: 169, g: 168, b: 232 },
        '/consulting': { r: 247, g: 169, b: 195 },
        '/consulting/enterprise-brand-identity': { r: 247, g: 169, b: 195 },
        '/consulting/enterprise-environment': { r: 247, g: 169, b: 195 },
        '/consulting/enterprise-product': { r: 247, g: 169, b: 195 },
        '/consulting/enterprise-graphic': { r: 247, g: 169, b: 195 },
        '/consulting/enterprise-beauty': { r: 247, g: 169, b: 195 },
        '/consulting/personal-color': { r: 247, g: 169, b: 195 },
        '/consulting/personal-therapy': { r: 247, g: 169, b: 195 },
        '/consulting/personal-image': { r: 247, g: 169, b: 195 },
        '/consulting/personal-branding': { r: 247, g: 169, b: 195 },
        '/program': { r: 253, g: 201, b: 131 },
        '/membership': { r: 116, g: 197, b: 233 },
        '/member-guide': { r: 116, g: 197, b: 233 }
    };

    // news 상세 페이지 경로 매칭 (동적 경로 처리)
    let gradientKey = pathname;
    if (pathname.startsWith('/news/notice/') || 
        pathname.startsWith('/news/press/') || 
        pathname.startsWith('/news/seminar/')) {
        gradientKey = pathname.split('/').slice(0, 3).join('/');
    }
    
    return pageColors[gradientKey] || pageColors[pathname] || null;
};

function SubPageTop({ title, subTitle }) {
    const location = useLocation();
    const pageColor = getPageColor(location.pathname);
    
    const gradientStyle = pageColor ? {
        '--top-gradient': `linear-gradient(180deg, 
            rgba(${pageColor.r}, ${pageColor.g}, ${pageColor.b}, 1) 0%, 
            rgba(${pageColor.r}, ${pageColor.g}, ${pageColor.b}, 0.6) 50%,
            rgba(255, 255, 255, 1) 100%)`
    } : {};

    return (
        <div className={styles.subPageTop} style={gradientStyle}>
            <div className={styles.subPageTopContent}>
                <div className={styles.subPageTopTitle}>
                    <p>{title}</p>
                </div>
                {/*           <div className={styles.subPageTopSubTitle}>
                    <p>{subTitle}</p>
                </div> */}
            </div>
        </div>
    )
}

export default SubPageTop;